import { ReactNode } from 'react'

/** One confirmation by the current password: what it is for and what it does once confirmed. */
export interface PasswordPromptRequest {
  title: string
  /** What the action costs — shown above the field when it is worth a warning. */
  warning?: ReactNode
  action: (currentPassword: string) => Promise<void>
}

export type AskForPassword = (request: PasswordPromptRequest) => void

export interface PasskeyItem {
  id: number
  name: string
  createdAt: string
  lastUsedAt: string | null
}

export interface AccountOverview {
  login: string
  secondFactorEnabled: boolean
  passkeys: PasskeyItem[]
  hasRecoveryCodes: boolean
}

export interface TotpEnrolment {
  secret: string
  uri: string
}

export { TOTP_CODE_LENGTH } from '../../auth/core/_models'
export const PASSWORD_MIN_LENGTH = 6
export const PASSWORD_MAX_LENGTH = 255
export const PASSKEY_NAME_MAX_LENGTH = 60
export const DEFAULT_PASSKEY_NAME = 'Ключ'
